
import { ReactNode, useState } from 'react';
import HologramCard from './HologramCard';

interface PCComponentProps {
  icon: ReactNode;
  title: string;
  description: string;
  glowColor?: string;
  onClick?: () => void;
  className?: string;
}

export default function PCComponent({ 
  icon, 
  title, 
  description, 
  glowColor = 'cyan',
  onClick,
  className = ''
}: PCComponentProps) {
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive(true);
    setTimeout(() => setIsActive(false), 200);
    onClick?.();
  };

  return (
    <HologramCard 
      glowColor={glowColor}
      onClick={handleClick}
      isActive={isActive}
      className={`group ${className}`}
    >
      <div className="flex flex-col items-center text-center space-y-4">
        {/* Icon with RGB glow */}
        <div className="relative">
          <div className="text-4xl text-white group-hover:scale-110 transition-transform duration-300">
            {icon}
          </div>
          <div className="absolute inset-0 text-4xl text-cyan-400 opacity-0 group-hover:opacity-50 group-hover:animate-ping">
            {icon}
          </div>
        </div>
        
        {/* Title */}
        <h3 className="text-lg font-bold text-white font-orbitron tracking-wider">
          {title}
        </h3>
        
        {/* Description */}
        <p className="text-sm text-gray-300 font-rajdhani">
          {description}
        </p>
        
        {/* Status indicator */}
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
          <span className="text-xs text-green-400 font-mono">READY</span>
        </div>
      </div>
    </HologramCard>
  );
}
